import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';

import styles from './fadeInContainerStyles.scss';

const FadeInContainer: React.FC<{ className?: string; children: React.ReactNode }> = ({
  className,
  children
}) => {
  const [visible, setVisible] = useState(false);
  const itemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting && setVisible(entry.isIntersecting));
    });
    const current = itemRef.current;
    if (!current) return;

    observer.observe(current);
    return (): void => observer.unobserve(current);
  }, []);

  return (
    <div
      className={classNames(styles.item, className, { [styles.itemVisible]: visible })}
      ref={itemRef}
    >
      {children}
    </div>
  );
};

export default FadeInContainer;
